
import { defineComponent, ref } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import Swal from "sweetalert2/dist/sweetalert2.js";
import * as Yup from "yup";

interface NewAddressData {
  firstName: string;
  lastName: string;
  country: string;
  address1: string;
  address2: string;
  town: string;
  state: string;
  postCode: string;
}

export default defineComponent({
  name: "new-address-modal",
  components: {
    ErrorMessage,
    Field,
    Form
  },
  setup() {
    const submitButtonRef = ref<null | HTMLButtonElement>(null);

    const newAddressData = ref<NewAddressData>({
      firstName: "",
      lastName: "",
      country: "",
      address1: "",
      address2: "",
      town: "",
      state: "",
      postCode: ""
    });

    const validationSchema = Yup.object().shape({
      firstName: Yup.string()
        .required()
        .label("First name"),
      lastName: Yup.string()
        .required()
        .label("Last name"),
      country: Yup.string()
        .required()
        .label("Country"),
      address1: Yup.string()
        .required()
        .label("Address Line 1"),
      address2: Yup.string()
        .required()
        .label("Address Line 2"),
      town: Yup.string()
        .required()
        .label("Town"),
      state: Yup.string()
        .required()
        .label("State/Province"),
      postCode: Yup.string()
        .required()
        .label("Post code")
    });

    const submit = () => {
      if (!submitButtonRef.value) {
        return;
      }

      //Disable button
      submitButtonRef.value.disabled = true;
      // Activate indicator
      submitButtonRef.value.setAttribute("data-kt-indicator", "on");

      console.log(newAddressData.value);

      setTimeout(() => {
        if (submitButtonRef.value) {
          submitButtonRef.value.disabled = false;

          submitButtonRef.value?.removeAttribute("data-kt-indicator");
        }

        Swal.fire({
          text: "Form has been successfully submitted!",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Ok, got it!",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        }).then(() => {
          window.location.reload();
        });
      }, 2000);
    };

    return {
      newAddressData,
      validationSchema,
      submit,
      submitButtonRef
    };
  }
});
